export const isPresent = (arr) => {
  return Array.isArray(arr) && arr?.length > 0;
};

export const isEmpty = (arr) => {
  return Array.isArray(arr) && arr?.length == 0;
};
